export default {
  getLoginUserByName: (state) => (inputValue) => {
    return state.loginUsers.filter(careworker => {
      var familyNameResult = null
      var nameResult = null
      var pronunciationResult = null
      var jobResult = null
      var positionResult = null
      var userIdResult = null
      var phoneNumberResult = null
      if (careworker.familyName !== null) {
        familyNameResult = careworker.familyName.match(inputValue)
      }
      if (careworker.name !== null) {
        nameResult = careworker.name.match(inputValue)
      }
      if (careworker.pronunciation !== null) {
        if (!careworker.foothold) {
          pronunciationResult = careworker.pronunciation.match(inputValue)
        }
      }
      if (careworker.job !== null) {
        if (!careworker.foothold) {
          jobResult = careworker.job.match(inputValue)
        }
      }
      if (careworker.position !== null) {
        if (!careworker.foothold) {
          positionResult = careworker.position.match(inputValue)
        }
      }
      if (careworker.userId !== null) {
        if (!careworker.foothold) {
          userIdResult = careworker.userId.match(inputValue)
        }
      }
      if (careworker.phoneNumber !== null) {
        phoneNumberResult = careworker.phoneNumber.match(inputValue)
      }
      if (familyNameResult !== null || nameResult !== null ||
        pronunciationResult !== null || jobResult !== null ||
        positionResult !== null || userIdResult !== null ||
        phoneNumberResult !== null) {
        var result = careworker.familyName + careworker.name + careworker.pronunciation + careworker.job + careworker.position + careworker.userId + careworker.phoneNumber
        return result.match(inputValue)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/loginUserModules/getters.js